"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TagSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var TagSVG = function TagSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.41,16.59l-14-14A1.966,1.966,0,0,0,14,2H4A2.0059,2.0059,0,0,0,2,4V14a1.966,1.966,0,0,0,.59,1.41l14,14a1.98,1.98,0,0,0,2.82,0l10-10A1.974,1.974,0,0,0,29.41,16.59ZM12,10a2,2,0,1,1-2-2A2.0059,2.0059,0,0,1,12,10Z"
  }));
};
exports.TagSVG = TagSVG;
TagSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TagSVG);
exports.default = _default;